import MineralsSilo from "@/components/MineralsSilo";

export default function OilGas() {
  return <MineralsSilo />;
}
